import React, { useState } from 'react';
import ClinicOverview from './ClinicOverview';
import AddressCard from './AddressCard';
import TimeZoneCard from './TimeZoneCard';
import LogoCard from './LogoCard';
import AssetsCard from './AssetsCard';
import PmsCard from './PmsCard';
const InfoTab = ({ onPmsTypeChange }) => {
    const [clinicLogo, setClinicLogo] = useState();

    const updateLogo = (logourl) => {
        setClinicLogo(logourl);
    };

    return (
        <div className="row g-3">
            <div className="col-xl-8">
                <ClinicOverview updateLogo={updateLogo} />
            </div>
            <div className="col-xl-4">
                <div className="d-flex flex-column gap-3">
                    <LogoCard logoUrl={clinicLogo} />
                    <AddressCard />
                    <TimeZoneCard />
                    <AssetsCard />
                    <PmsCard onPmsTypeChange={onPmsTypeChange} />
                </div>
            </div>
        </div>
    );
};

export default InfoTab;
